import { createContext, useContext } from "react";

import type { FlowTemplate } from "../../../../types";

interface FlowTemplateContextType {
  flowTemplate: FlowTemplate;
  isEditing: boolean;

  // Methods
  handleSave: () => void;
  handleDiscard: () => void;
  handleStartEdit: () => void;
}

const FlowTemplateContext = createContext<FlowTemplateContextType | undefined>(
  undefined,
);

export const FlowTemplateProvider = FlowTemplateContext.Provider;

export function useFlowTemplateContext() {
  const context = useContext(FlowTemplateContext);

  if (!context) {
    throw new Error(
      "useFlowTemplateContext must be used within a FlowTemplateProvider",
    );
  }

  return context;
}
